import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';

const useStyles = buildUseStyles('ManagedAccountOpeningItemCardChip', (theme) => ({
  chip: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
    flexShrink: 0,
    fontWeight: theme.typography.fontWeightBold,
  },
  icon: {
    color: theme.palette.common.white,
  },
}));


const ManagedAccountOpeningItemCardChip = ({ className }) => {
  const classes = useStyles();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Chip size={'small'} label="Open" icon={<CheckCircleIcon className={classes.icon} />} className={classes.chip} />
    </Box>
  );
};

ManagedAccountOpeningItemCardChip.defaultProps = {
  className: '',
};

ManagedAccountOpeningItemCardChip.propTypes = {
  className: PropTypes.string,
};

export default ManagedAccountOpeningItemCardChip;
